import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "student-analysis-pages-container" }
const _hoisted_2 = { class: "filter-section" }
const _hoisted_3 = { class: "filter-item" }
const _hoisted_4 = { class: "filter-actions" }
const _hoisted_5 = {
  key: 0,
  class: "charts-area"
}
const _hoisted_6 = { class: "chart-title" }
const _hoisted_7 = {
  key: 1,
  class: "empty-state"
}

import { ref, computed, watch } from 'vue'
import VChart from 'vue-echarts'
import { getPassLine, getUpDownDetailAnalysis } from '@/servers/api/analysis'
import { message } from 'ant-design-vue'

// 接收父组件传入的学生信息

export default /*@__PURE__*/_defineComponent({
  __name: 'StudentAnalysisPages',
  props: {
    studentId: {},
    studentName: {},
    classInfo: {}
  },
  setup(__props: any) {

const props = __props

// 1. 响应式状态
const studentList = ref<any[]>([])
const options = ref<any[]>([])
const messageReturn = ref<any[]>([])
const mode = ref<'rank'|'score'>('score')
const totalData = ref<any>({})

// 2. 计算属性
const studentId = computed(() => props.studentId)
const studentName = computed(() => props.studentName || '选中学生')

// 3. 科目配置
const subjects = ['总分','语文', '数学', '英语']

const subject_selection = computed(() => {
  for (const subject of props.classInfo?.subject_selection || []) {
    if (subject.includes('物')) {
      subjects.push('物理')
    }else if (subject.includes('化')) {
      subjects.push('化学')
    } else if (subject.includes('生')) {
      subjects.push('生物')
    } else if (subject.includes('史')) {
      subjects.push('历史')
    } else if (subject.includes('地')) {
      subjects.push('地理')
    } else if (subject.includes('政')) {
      subjects.push('政治')
    }
  }
  return subjects
})
const fieldMappingRank = {
  '语文': '语文段次',
  '数学': '数学段次',
  '英语': '英语段次',
  '物理': '物理段次',
  '化学': '化学段次',
  '生物': '生物段次',
  '历史': '历史段次',
  '地理': '地理段次',
  '政治': '政治段次'
}
const fieldMappingScore = {
  '语文': '语文',
  '数学': '数学',
  '英语': '英语',
  '物理': '物理',
  '化学': '化学',
  '生物': '生物',
  '历史': '历史',
  '地理': '地理',
  '政治': '政治'
}

// 4. 监听学生ID变化
watch(studentId, (newId) => {
  if (newId) {
    fetchStudentData(Number(newId))
  } else {
    messageReturn.value = []
    options.value = []
  }
}, { immediate: true })

// 5. 获取学生成绩数据
const fetchStudentData = async (stuId: number) => {
  try {
    const result = await getUpDownDetailAnalysis({ student_id: stuId, nums: 9999 })
    if (result?.data) {
      messageReturn.value = result.data
      generateTable(result.data, mode.value === 'rank' ? fieldMappingRank : fieldMappingScore)
    } else {
      message.warning('未查询到学生成绩数据')
      messageReturn.value = []
      options.value = []
    }
  } catch (error) {
    console.error('获取学生成绩失败:', error)
    message.error('获取成绩数据失败')
  }
}

// 6. 生成图表数据
const generateTable = async (examData: any[], types: Record<string, string>) => {
 
  const tempData: Record<string, any> = subject_selection.value.reduce((acc, subject) => {
    acc[subject] = { x_name: [], y_score: [] }
    return acc
  }, {})  
  for (const item of examData) {
    if (!item.exam?.length) continue
    
    const examName = item.exam[0].name
    const examId = item.exam[0].id
    
    // 获取特控线数据（行式：每行一个科目，按 line_group_id 分组聚合）
    let selectedPassLine = null
    try {
      if (examId) {
        const passLineRes = await getPassLine({ exam_id: examId })
        if (passLineRes?.data) {
          if (Array.isArray(passLineRes.data) && passLineRes.data.length > 0) {
            // 行式聚合：取第一个分数线组组装成 {科目: 分数}
            const groups = new Map<number, Record<string, number>>()
            passLineRes.data.forEach((row: any) => {
              const gid = row?.line_group_id
              if (gid == null) return
              if (!groups.has(gid)) groups.set(gid, {})
              if (row.subject != null && row.score != null) {
                groups.get(gid)![row.subject] = row.score
              }
            })
            selectedPassLine = groups.values().next().value || null
          } else {
            selectedPassLine = passLineRes.data
          }
        }
      }
    } catch (error) {
      console.warn('获取特控线失败:', error)
    }

    // 处理总分
    tempData['总分'].x_name.push(examName)
    tempData['总分'].y_score.push({
      score: item['总分'] ?? 0,
      line: selectedPassLine?.['总分'] ?? 0
    })

    // 处理各科目
    for (const [subject, field] of Object.entries(types)) {
      console.log("@@",subject_selection.value)
      if (subject_selection.value.includes(subject)) {
        tempData[subject].x_name.push(examName)
        tempData[subject].y_score.push({
          score: item[field] ?? 0,
          line: selectedPassLine?.[field] ?? 0
        })
      }
    }
  }

  totalData.value = tempData
  options.value = subjects.map(subject => getSubjectOption(subject))
}

// 7. 图表配置生成
const getSubjectOption = (subject: string) => {
  const subjectData = totalData.value[subject] || { x_name: [], y_score: [] }
  const scores = subjectData.y_score.map((d: any) => d.score || 0)
  const lines = subjectData.y_score.map((d: any) => d.line || 0)

  return {
    tooltip: { 
      trigger: 'axis',
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
      borderColor: '#ccc',
      borderWidth: 1,
      textStyle: { color: '#333' }
    },
    legend: { 
      data: ['本人成绩', '特控线'],
      top: '10%',
      textStyle: { color: '#666' }
    },
    xAxis: { 
      type: 'category', 
      data: subjectData.x_name,
      axisLabel: { 
        textStyle: { fontSize: 12, fontFamily: 'SimHei', color: '#666' }
      },
      axisLine: { lineStyle: { color: '#ddd' } }
    },
    yAxis: { 
      type: 'value',
      axisLabel: { textStyle: { color: '#666' } },
      splitLine: { lineStyle: { type: 'dashed', color: '#eee' } }
    },
    series: [
      {
        name: '本人成绩',
        type: 'line',
        data: scores,
        itemStyle: { color: '#1890ff', shadowBlur: 3 },
        lineStyle: { width: 3, type: 'solid' },
        smooth: true,
        symbolSize: 6
      },
      {
        name: '特控线',
        type: 'line',
        data: lines,
        itemStyle: { color: '#EE6666', shadowBlur: 3 },
        lineStyle: { width: 3, type: 'dashed' },
        smooth: true,
        symbolSize: 6
      }
    ],
    grid: {
      left: '5%',
      right: '5%',
      top: '20%',
      bottom: '15%',
      containLabel: true
    }
  }
}

// 8. 外部查询触发
const fetchData = () => {
  if (!studentId.value) {
    message.warning('请先选择学生')
    return
  }
  generateTable(
    messageReturn.value,
    mode.value === 'rank' ? fieldMappingRank : fieldMappingScore
  )
}

return (_ctx: any,_cache: any) => {
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "header" }, [
      _createElementVNode("h2", null, "学生成绩趋势分析"),
      _createElementVNode("p", null, "查看学生各科目历次考试成绩或排名变化")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_row, { gutter: 16 }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: 24,
            sm: 12,
            md: 8
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "filter-label" }, "数据类型：", -1)),
                _createVNode(_component_a_radio_group, {
                  value: mode.value,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((mode).value = $event)),
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: "rank" }, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode("按名次", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: "score" }, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode("按分数", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, {
            xs: 24,
            sm: 12,
            md: 4
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: fetchData
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode("查询", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (studentId.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subject_selection.value, (subject, index) => {
            return (_openBlock(), _createBlock(_component_a_card, {
              key: subject,
              class: "chart-card",
              bordered: false
            }, {
              title: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, _toDisplayString(studentName.value) + _toDisplayString(subject) + _toDisplayString(mode.value == 'rank' ? '历次排名':'成绩'), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(VChart), {
                  option: options.value[index],
                  autoresize: "",
                  class: "chart-wrapper"
                }, null, 8, ["option"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_a_empty, { description: "请先选择学生" })
        ]))
  ]))
}
}

})